 $(window).on('load', function() {
       var changeImgSrc = $('.dmdFancyBox a:first-child img').attr('src');
          var selectedButtonSrc = $('.product-gallery--media[data-gallery-selected=true] img').attr('src');
          $('.dmdFancyBoxImgs:first-child img').attr('src', selectedButtonSrc);
      $('button.custom_gallery_image').on('click', function() {
      // console.log('click-img')
      setTimeout(function() {
          var selectedButtonSrc = $('.product-gallery--media[data-gallery-selected=true] img').attr('src');
          $('.dmdFancyBoxImgs:first-child img').attr('src', selectedButtonSrc)
      }, 500);
    });

      $('.dmdFancyBox img').on('click', function() {
        $('.dmdFancyBoxImgs:first-child img').attr('src', changeImgSrc);
      });
    });
   $(document).ready(function() {
        $('.options-selection__option-value-input').on('change', function() {
          if ($(this).is(':checked')) {
              var selectedButtonSrc = $('.product-gallery--media[data-gallery-selected=true] img').attr('src');
              $('.dmdFancyBoxImgs:first-child img').attr('src', selectedButtonSrc);
          }
         });
   });
   $('[data-fancybox="images"]').fancybox({
    thumbs : {
      autoStart: true,
      axis      : 'x'
    }
  });
   $('.dmdFancyBox a').click(function(){
       $('.fancybox-button, .fancybox-thumbs__list a').on('click', function() {
          setTimeout(function() {
            var currentSlideImg = $('.fancybox-slide--current img').attr('src');
            $('.dmdFancyBoxImgs:first-child img').attr('src', currentSlideImg);
          }, 100);
        });
  });